export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5257.d2a2e563.jpg";